import { render, staticRenderFns } from "./equipment-db.component.vue?vue&type=template&id=4c986e40&scoped=true"
import script from "./equipment-db.component.ts?vue&type=script&lang=ts&external"
export * from "./equipment-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c986e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c986e40')) {
      api.createRecord('4c986e40', component.options)
    } else {
      api.reload('4c986e40', component.options)
    }
    module.hot.accept("./equipment-db.component.vue?vue&type=template&id=4c986e40&scoped=true", function () {
      api.rerender('4c986e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/is-loop/equipment-db/equipment-db.component.vue"
export default component.exports